import React from "react";
import CustomDropdownSelect from "src/business-types/grocery/components/DropdownSelect";

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
}

const CATEGORY_TYPE_OPTIONS = [
  { _id: "Services", CategoryName: "Services" },
  { _id: "Products", CategoryName: "Products" },
];

const CategoryTypeSelect: React.FC<Props> = ({ value, onChange, disabled }) => {
  return (
    <CustomDropdownSelect
      name="categoryType"
      title="Type"
      value={value}
      options={CATEGORY_TYPE_OPTIONS}
      titleofSelect="Select category"
      onChange={(val) =>
        onChange({
          target: { value: val },
        } as React.ChangeEvent<HTMLSelectElement>)
      }
      mandatory
      disabled={disabled}
    />
  );
};

export default CategoryTypeSelect;
